import { useEffect, FC } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Box, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { MgState, QuestionnaireEntityInterface } from '@types';
import { translate } from '@utils';
import { WellDone } from '@images/icons';
import { makeAllQuestionnaires } from '@actions/questionnaireActions';
import { setAnswerFiltersPartially } from '@actions/answersPageAction';
import '../index.scss';

interface FilterByCheckboxProps {
  id?: string;
  anchorEl?: HTMLElement;
  open: boolean;
  handleClose: () => void;
  setAnchorEl: (event) => void;
}
export const FilterBySelect: FC<FilterByCheckboxProps> = ({
  id,
  anchorEl,
  open,
  handleClose,
  setAnchorEl,
}) => {
  const dispatch = useDispatch();

  const filterQuestionnaireTitle = useSelector<MgState, string>(
    ({ answersPage }) => answersPage.filters?.questionnaireTitle
  );
  const questionnaires = useSelector<MgState, QuestionnaireEntityInterface[]>(
    ({ questionnaire }) => questionnaire.questionnaires,
    shallowEqual
  );

  useEffect(() => {
    dispatch(makeAllQuestionnaires());
  }, []);

  return (
    <Menu
      id={id}
      className="filter-menu"
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuItem
        onClick={() => {
          setAnchorEl(null);
          dispatch(setAnswerFiltersPartially({ questionnaireTitle: null }));
        }}
        divider
        key={' Dct'}
      >
        <ListItemIcon>{!filterQuestionnaireTitle && <WellDone />}</ListItemIcon>
        <Box component="span" width={22}>
          {translate('all')}
        </Box>
      </MenuItem>
      {questionnaires.map(({ title, id }) => {
        return (
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              dispatch(setAnswerFiltersPartially({ questionnaireTitle: title }));
            }}
            key={id}
          >
            <ListItemIcon>{filterQuestionnaireTitle === title && <WellDone />}</ListItemIcon>
            <Box component="span">{title}</Box>
          </MenuItem>
        );
      })}
    </Menu>
  );
};
